import { ARTIFACT_TAG_REGEX, ARTIFACT_MARKDOWN_LINK_REGEX } from '../constants'

/**
 * Strips artifact markdown links while preserving descriptive text
 * Converts [descriptive text](CONVERSATION://id) -> descriptive text
 * Useful for displaying text previews without clickable links
 */
export function stripArtifactLinks(text: string): string {
  return text.replace(ARTIFACT_MARKDOWN_LINK_REGEX, '$1')
}

/**
 * Cleans artifact tags from text for copying to clipboard
 * Removes [CONVERSATION://id], [AUDIO_NOTE://id], and [INSIGHT://id] tags
 * Also removes new markdown link format [text](CONVERSATION://id)
 */
export function cleanArtifactTextForCopy(text: string): string {
  const cleaned = text
    // Remove old artifact tags: [CONVERSATION://id]
    .replace(ARTIFACT_TAG_REGEX, '')
    // Remove new markdown link format: [text](CONVERSATION://id)
    .replace(/\[([^\]]+)\]\((CONVERSATION|AUDIO_NOTE|INSIGHT):\/\/[^\)]+\)/g, '')
    // Remove standalone artifact link text
    .replace(/^(audio note|highlight|conversation|artifact)$/gm, '')
    // Clean up multiple spaces on same line (but preserve newlines)
    .replace(/[^\S\n]+/g, ' ')
    // Clean up multiple consecutive newlines
    .replace(/\n{3,}/g, '\n\n')
    .trim()

  return cleaned
}
